import { AlreadyBookedErrorPage } from '@/app/pages/user-form/already-booked-error-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user-form/errors/already-booked-error')({
  component: AlreadyBookedErrorPage,
});
